import {Theme} from "../../stem-core/ui/style/Theme";

// Theme to be used inside the wallet portion of the widget
export const WidgetWalletTheme = Theme.Global.fork("WidgetWallet", {
    ERROR_COLOR: "#FF8800", // Needs to be readable on green
    LINK_COLOR: "#00C3EB",

    TEXT_PRIMARY_COLOR: props => props.WALLET_2,

    BUTTON_PRIMARY_BACKGROUND: "#1A8289",
    BUTTON_PRIMARY_HOVER_BACKGROUND: props => props.WALLET_10,

    TOGGLE_BACKGROUND: props => props.WALLET_17,
    TOGGLE_DISABLED_BACKGROUND: props => props.WALLET_7,
    TOGGLE_SHADOW: "0 1px 1px rgba(0,0,0,.14), 0 2px 1px  -1px rgba(0,0,0,.12), 0 1px 3px rgba(0,0,0,.2)",
    TOGGLE_COLOR: props => props.WALLET_2,

    INPUT_BACKGROUND: props => props.WALLET_15,
    INPUT_PLACEHOLDER_COLOR: props => props.WALLET_8,
    INPUT_TEXT_COLOR: props => props.WALLET_2,

    POPUP_BORDER: props => "1px solid " + props.WALLET_16,
    POPUP_BACKGROUND: props => props.WALLET_15,
    POPUP_MAX_WIDTH: 256,

    MERCHANT_FRAME_CLOSE_BUTTON_COLOR: props => props.WHITE,
});

export const WidgetMerchantTheme = Theme.Global.fork("WidgetMerchant", {
    BUTTON_PRIMARY_BACKGROUND: "#000000",
    BUTTON_PRIMARY_HOVER_BACKGROUND: "#000000",
    BUTTON_PRIMARY_SHADOW: "none",
    BUTTON_PRIMARY_TEXT_SHADOW: "none",

    LINK_COLOR: props => props.MERCHANT_2,
    LINK_COLOR_HOVER: "#000000",
});
